document.addEventListener('DOMContentLoaded', () => {
  initMvSwiper();
  initPickupSwiper();
});

/**
 * MV Swiper
 */
const initMvSwiper = () => {
  const swiperEl = document.querySelector('.js-mv-swiper');
  const pauseBtn = document.querySelector('.js-mv-pause-btn');

  if (!swiperEl || typeof Swiper === 'undefined') return;

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
  const mediaQuery = window.matchMedia('(max-width: 1040px)');
  let mvSwiper = null;
  let canLoop = false;
  let isPaused = false;

  const pauseIcon = pauseBtn?.dataset.pauseIcon;
  const playIcon = pauseBtn?.dataset.playIcon;
  const pauseImg = pauseBtn?.querySelector('img');

  const resetPauseButton = () => {
    isPaused = false;

    if (!pauseBtn) return;

    pauseBtn.classList.toggle('-hidden', !canLoop);
    pauseBtn.setAttribute('aria-label', 'スライドを一時停止する');
    pauseBtn.setAttribute('aria-pressed', 'false');

    if (pauseImg && pauseIcon) {
      pauseImg.src = pauseIcon;
    }
  };

  const createSwiper = () => {
    // ループと自動再生を有効にする最小枚数: SPは3枚、PCは5枚。
    canLoop = mediaQuery.matches ? slideCount >= 3 : slideCount >= 5;
    resetPauseButton();

    mvSwiper = new Swiper(swiperEl, {
      loop: canLoop,
      speed: 800,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 0,

      autoplay: canLoop
        ? {
            delay: 4000,
            disableOnInteraction: false,
          }
        : false,

      pagination: {
        el: '.js-mv-pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.js-mv-swiper-next',
        prevEl: '.js-mv-swiper-prev',
      },

      breakpoints: {
        1041: {
          slidesPerView: 1.18,
          spaceBetween: 40,
        },
      },
    });
  };

  const recreateSwiper = () => {
    if (mvSwiper) {
      mvSwiper.destroy(true, true);
    }

    createSwiper();
  };

  createSwiper();
  mediaQuery.addEventListener('change', recreateSwiper);

  if (!pauseBtn) return;

  pauseBtn.addEventListener('click', () => {
    if (!canLoop || !mvSwiper?.autoplay) return;

    isPaused = !isPaused;

    if (isPaused) {
      mvSwiper.autoplay.stop();

      if (pauseImg && playIcon) {
        pauseImg.src = playIcon;
      }

      pauseBtn.setAttribute('aria-label', 'スライドを再生する');
      pauseBtn.setAttribute('aria-pressed', 'true');
    } else {
      mvSwiper.autoplay.start();

      if (pauseImg && pauseIcon) {
        pauseImg.src = pauseIcon;
      }

      pauseBtn.setAttribute('aria-label', 'スライドを一時停止する');
      pauseBtn.setAttribute('aria-pressed', 'false');
    }
  });
};

/**
 * Pickup Swiper
 * 1040px以下のみ有効
 */
const initPickupSwiper = () => {
  const swiperEl = document.querySelector('.js-pickup-swiper');

  if (!swiperEl || typeof Swiper === 'undefined') return;

  const mediaQuery = window.matchMedia('(max-width: 1040px)');
  let pickupSwiper = null;

  const createSwiper = () => {
    if (pickupSwiper || !mediaQuery.matches) return;

    pickupSwiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1.15,
      spaceBetween: 24,
      centeredSlides: true,
      speed: 800,
      allowTouchMove: true,

      pagination: {
        el: '.js-pickup-pagination',
        clickable: true,
      },

      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false,
      //   reverseDirection: false,
      // },
    });
  };

  const destroySwiper = () => {
    if (!pickupSwiper || mediaQuery.matches) return;

    pickupSwiper.destroy(true, true);
    pickupSwiper = null;
  };

  const toggleSwiper = () => {
    if (mediaQuery.matches) {
      createSwiper();
    } else {
      destroySwiper();
    }
  };

  toggleSwiper();

  mediaQuery.addEventListener('change', toggleSwiper);
};
